// Colors
export const blueLight = "#065ce6";
export const blue = "#063ce6";
export const blueDark = "#0907d4";
export const orangeLight = "#ffd1b5";
export const orange = "#fab496";
export const orangeDark = "#f0916c";
export const orangeE8 = "#e89e42";
export const greenLight = "#63d1b3";
export const green = "#00bea3";
export const greenDark = "#039296";
export const redLight = "#f3668e";
export const red = "#ec454d";
export const redDark = "#c02035";
export const greyLight = "#f4f4f4";
export const greySecondary = "#e8e8e8";
export const grey = "#c5c5c5";
export const greyDark = "#707070";
export const greyF7 = "#f7f7f7";
export const grey8D = "#8d8d8d";
export const white = "#fff";
export const black = "#000";
export const black1D = "#1d1d1d";
export const yellow = "#f5ba3f";

// Others
export const drawerWidth = "240px";
export const tooltipZIndex = 1200;
